module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Standard - 299€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/contract.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
    staticClass: "light-frame"
  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
    staticClass: "md-title"
  }, [_vm._v("Premium - 999€ TTC")]), _vm._v(" "), _c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("I am assisted and defended by a lawyer ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
    attrs: {
      "src": "/static/lawyer.svg"
    }
  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "light-frame visa-frame"
  }, [_c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "32px"
    }
  }, [(_vm.$route.params.cart == 'CRRV') ? _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "team-visa@getmyvisatofrance.com"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Offre Standard CRRV"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount",
      "value": "299.00"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "EUR"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "button_subtype",
      "value": "services"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "image",
      "src": "https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif",
      "border": "0",
      "name": "submit",
      "alt": "PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('form', {
    attrs: {
      "action": "https://www.paypal.com/cgi-bin/webscr",
      "method": "post",
      "target": "_top"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "business",
      "value": "team-visa@getmyvisatofrance.com"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lc",
      "value": "US"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "item_name",
      "value": "Offre Premium"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "amount",
      "value": "999.00"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "currency_code",
      "value": "EUR"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "button_subtype",
      "value": "services"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "no_note",
      "value": "0"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "bn",
      "value": "PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "image",
      "src": "https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif",
      "border": "0",
      "name": "submit",
      "alt": "PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "border": "0",
      "src": "https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif",
      "width": "1",
      "height": "1"
    }
  })]) : _vm._e()])])], 1) : _c('div', [_c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onClickContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "padding-bottom": "16px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "40%",
      "max-width": "200px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/paypal.svg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('h2', [_vm._v("Payment with Paypal")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51828192","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutPaypal.vue
// module id = 736
// module chunks = 3